import { useState } from 'react';
import type { DrillView } from '../components/analytics/drillView';

/**
 * Drill stack: the push/pop history of drill views. Deliberately URL-free —
 * the dashboard page syncs the CURRENT view into the URL itself; chat view
 * cards each own a private stack and must not touch the page URL.
 */
export function useDrillStack(initial: DrillView) {
  const [stack, setStack] = useState<DrillView[]>([initial]);

  const push = (next: DrillView) => setStack(prev => [...prev, next]);
  const popTo = (index: number) => setStack(prev => prev.slice(0, index + 1));
  const reset = (view: DrillView = { kind: 'overview' }) => setStack([view]);

  const view: DrillView = stack.at(-1) ?? { kind: 'overview' };

  return { stack, view, push, popTo, reset };
}
